import { RouteConfig } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireAuthenticated } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration, checkSitterOnboarding } from '@/router/guards/completionGuards';
import MessagesView from '@/apps/messages/MessagesView.vue';

const messagingAccessGuards = combineGuards([requireAuthenticated, checkPremiumParentRegistration, checkSitterOnboarding]);

const messagesRoutes: RouteConfig[] = [
  {
    path: '/messages',
    name: 'Messages',
    component: MessagesView,
    beforeEnter: messagingAccessGuards,
    meta: { shouldHideFooter: true },
  },
];

export default messagesRoutes;
